'use strict';

var React = require('react'),
    ZineLink = require('../atoms/ZineLink'),
    ZineImage = require('../atoms/ZineImage'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    PropTypes = React.PropTypes;

require('./ZineInfo.less');

var ZineInfo = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    zine: React.PropTypes.object.isRequired,
    noLink: PropTypes.bool,
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  },

  getDefaultProps() {
    return {
      size: 'medium',
    };
  },

  getCSSModifiers() {
    return [
      this.props.size,
    ];
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderImage()}
        {this.renderBody()}
      </div>
    );
  },

  renderImage() {
    var image = (
      <ZineImage zine={this.props.zine}
                 size={this.props.imageSize || this.props.size} />
    );

    if (this.props.noLink) {
      return image;
    }

    return (
      <ZineLink zine={this.props.zine}
                className='ZineInfo-avatar'
                showTitle>
        {image}
      </ZineLink>
    );
  },

  renderBody() {
    var title = this.renderTitle(),
        isInNavBar = this.props.context === 'NavBar';

    if (!title) {
      return;
    }

    return (
      <div className='ZineInfo-body'>
        {isInNavBar &&
          'in '
        }
        {title}
      </div>
    );
  },

  renderTitle() {
    if (this.props.noLink) {
      return (
        <span className='ZineInfo-title'>
          {this.props.zine.title}
        </span>
      );
    }

    return (
      <ZineLink zine={this.props.zine}
                className='ZineInfo-title' bold />
    );
  },

});

module.exports = ZineInfo;



/** WEBPACK FOOTER **
 ** ./organisms/ZineInfo.jsx
 **/